import { SUPPORT_TICKET, SUPPORT_TICKET_SUCCESS, SUPPORT_TICKET_ERROR, SUPPORT_TICKET_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SupportTicket = (state = initialState, action) => {
  switch (action.type) {
    case SUPPORT_TICKET:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SUPPORT_TICKET_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SUPPORT_TICKET_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SUPPORT_TICKET_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SupportTicket;
